import { themeStringToObject } from '@atlaskit/tokens';

import { DEFAULT_COLOR_MODE, themeColorModes } from './constants';

export const updateThemeWithDefaultValues = (themeString: string) => {
	const themeObject = themeStringToObject(themeString);
	let colorMode = themeObject?.colorMode;

	// Validate theme value
	if (colorMode && !themeColorModes.includes(colorMode)) {
		// very unlikely but…
		// eslint-disable-next-line no-console
		console.error('Unrecognized theme value:', colorMode);
		colorMode = DEFAULT_COLOR_MODE;
	}

	// Return theme object with validated/defaulted colorMode
	return {
		...themeObject,
		colorMode: colorMode ?? DEFAULT_COLOR_MODE,
	};
};
